package uz.ferro.shop.model

enum class AccessKeyType {
    PRODUCT
}